export const columnListDefault = [
  {
    field: 'projectNo',
    title: '维修项目编号',
    visible: true,
  },
  {
    field: 'typeStr',
    title: '维修类型',
    visible: true,
  },
  {
    field: 'location',
    title: '维修地点',
    visible: true,
  },
  {
    field: 'content',
    title: '维修内容',
    visible: true,
  },
  {
    field: 'estimatedCost',
    title: '维修预估费用（元）',
    visible: true,
  },
  {
    field: 'plan',
    title: '维修方案',
    visible: true,
  },
  {
    field: 'actualCost',
    title: '维修实际费用（元）',
    visible: true,
    editRender: {
      name: 'inputCost',
      // attrs: { type: 'number' },
    },
  },
  {
    field: 'completeDate',
    title: '完工日期',
    visible: true,
    editRender: {
      name: 'datePicker',
      type: 'date',
      // attrs: { type: 'date' },
    },
  },
];
